export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

// normalize CSS across browsers
import './src/css/normalize.css'

// custom CSS styles
import './src/css/style.css'
